import BaseClass from "../BaseClass";

export default class UserList extends BaseClass {

    constructor(element) {
        super(element);

        this.listsLoadedListener = null;
        this.contentLoadedListener = null;
        this.usersLoadedListener = null;
        this.reloadListener = null;
        this.createListener = null;
        this.renameListener = null;
        this.deleteListener = null;
        this.resizeListener = null;
        this.listElementsListener = null;
        this.userElementsListener = null;
        this.backButtonListener = null;
        this.fansButtonListener = null;
        this.selectAllButtonListener = null;
        this.deselectAllButtonListener = null;
        this.mobileLayout = false;
        this.listElements = [];
        this.userElements = [];
        this.backButton = null;
        this.fansUrl = null;
        this.fansButton = null;
        this.selectAllButton = null;
        this.deselectAllButton = null;
        this.checkedCounter = 0;

        this.init();
    }

    init() {
        let mySelf = this;

        this.listsLoadedListener = function () {
            mySelf.listsLoadedEvent();
        }
        $(document).on('user-lists:loaded', this.listsLoadedListener);

        this.contentLoadedListener = function () {
            mySelf.contentLoadedEvent();
        }
        $(document).on('user-list-content:loaded', this.contentLoadedListener);

        this.usersLoadedListener = function () {
            mySelf.usersLoadedEvent();
        }
        $(document).on('user-list-users:loaded', this.usersLoadedListener);

        this.reloadListener = function () {
            mySelf.reloadEvent();
        }
        $(document).on('user-list:reload', this.reloadListener);

        this.createListener = function (event, data) {
            mySelf.createEvent(data);
        }
        $(document).on('user-list:created', this.createListener);

        this.renameListener = function (event, data) {
            mySelf.renameEvent(data);
        }
        $(document).on('user-list:renamed', this.renameListener);

        this.deleteListener = function () {
            mySelf.deleteEvent();
        }
        $(document).on('user-list:deleted', this.deleteListener);

        this.resizeListener = function () {
            mySelf.resizeEvent();
        }
        $(document).on('content:resized', this.resizeListener);

        this.listElementsListener = function (event) {
            mySelf.listElementsEvent(event);
        }

        this.userElementsListener = function (event) {
            mySelf.userElementsEvent(event);
        }

        this.backButtonListener = function () {
            mySelf.backButtonEvent();
        }

        this.fansButtonListener = function () {
            mySelf.fansButtonEvent();
        }

        this.selectAllButtonListener = function () {
            mySelf.selectEvent(true);
        }

        this.deselectAllButtonListener = function () {
            mySelf.selectEvent(false);
        }

        mySelf.resizeEvent();
    }

    listsLoadedEvent() {
        if (this.listElements.length > 0) {
            this.listElements.off('click', this.listElementsListener);
            this.listElements = [];
        }

        let listElements = this.$element.find('[data-list-element-id]');
        if (listElements.length > 0) {
            this.listElements = listElements;
            this.listElements.on('click', this.listElementsListener);
        }

        if (this.mobileLayout) {
            this.highlightCurrentListElement(false);
        }
    }

    contentLoadedEvent() {
        // Normale Ansicht
        if (this.backButton != null) {
            this.backButton.off('click', this.backButtonListener);
            this.backButton = null;
        }

        const backButton = this.$element.find('[data-type="back-button"]');
        if (backButton.length > 0) {
            this.backButton = backButton;
            this.backButton.on('click', this.backButtonListener);
        }

        // Hinzufügen/Entfernen Ansicht
        if (this.fansButton != null) {
            this.fansButton.off('click', this.fansButtonListener);
            this.fansButton = null;

            if (this.selectAllButton != null && this.deselectAllButton != null) {
                this.selectAllButton.off('click', this.selectAllButtonListener);
                this.selectAllButton = null;

                this.deselectAllButton.off('click', this.deselectAllButtonListener);
                this.deselectAllButton = null;
            }

            this.checkedCounter = 0;
        }

        const fansButton = this.$element.find('[data-type="fans-button"]');
        const fansUrl = fansButton.data('fans-url');
        if (fansButton.length > 0 && fansUrl != undefined) {
            this.fansButton = fansButton;
            this.fansUrl = fansUrl;
            this.fansButton.on('click', this.fansButtonListener);

            const selectAllButton = this.$element.find('[data-type="select-all-button"]');
            const deselectAllButton = this.$element.find('[data-type="deselect-all-button"]');
            if (selectAllButton.length > 0 && deselectAllButton.length > 0) {
                this.selectAllButton = selectAllButton;
                this.selectAllButton.on('click', this.selectAllButtonListener);

                this.deselectAllButton = deselectAllButton;
                this.deselectAllButton.on('click', this.deselectAllButtonListener);
            }
        }
    }

    usersLoadedEvent() {
        if (this.fansButton != null) {
            if (this.userElements.length > 0) {
                this.userElements.off('click', this.userElementsListener);
                this.userElements = [];
            }

            const userElements = this.$element.find('[data-type="user-element"]');
            if (userElements.length > 0) {
                this.userElements = userElements;
                this.userElements.on('click', this.userElementsListener);
            }
        }
    }

    reloadEvent() {
        this.reloadLists();
    }

    createEvent(data) {
        if (this.mobileLayout) {
            this.showLists(false);
            this.showUsers(true);
        }

        this.reloadUserListContent(true, data.userListHashId);
        this.updateUserListHashId(data.userListHashId);
        this.reloadLists();
    }

    renameEvent(data) {
        this.updateListName(data.listName);
        this.reloadLists();
    }

    deleteEvent() {
        if (this.mobileLayout) {
            this.showLists(true);
            this.showUsers(false);
        }

        this.reloadUserListContent(true);
        this.updateUserListHashId(null);
        this.reloadLists();
    }

    resizeEvent() {
        let minDesktopWidth = 992;
        let currentWidth = $(window).width();

        if (minDesktopWidth > currentWidth) {
            if (!this.mobileLayout) {
                this.showLists(true);
                this.showUsers(false);
                this.highlightCurrentListElement(false);
            }

            this.mobileLayout = true;
        } else {
            if (this.mobileLayout) {
                this.showLists(true);
                this.showUsers(true);
                this.highlightCurrentListElement(true);
            }

            this.mobileLayout = false;
        }
    }

    listElementsEvent(event) {
        if (this.mobileLayout) {
            this.showLists(false);
            this.showUsers(true);
        }

        let listElement = $(event.currentTarget);
        this.updateWindowUrl(listElement.data('user-lists-view-url'));
        this.updateUserListHashId(listElement.data('list-element-id'));
    }

    userElementsEvent(event) {
        let clickedElement = $(event.target);

        if (clickedElement.is('[data-type="check"]')) {
            let checkboxElement = $(event.currentTarget).find('[data-subtype="user-element-checkbox"]')[0];

            if (checkboxElement.checked) {
                checkboxElement.checked = false;
                this.checkedCounter--;
            } else {
                checkboxElement.checked = true;
                this.checkedCounter++;
            }

            this.updateFansButton();
        } else if (clickedElement.is('[data-type="checkbox"]')) {
            let checkboxElement = $(event.currentTarget).find('[data-subtype="user-element-checkbox"]')[0];

            if (checkboxElement.checked) {
                this.checkedCounter++;
            } else {
                this.checkedCounter--;
            }

            this.updateFansButton();
        }
    }

    backButtonEvent() {
        if (this.mobileLayout) {
            this.showUsers(false);
            this.showLists(true);
            this.highlightCurrentListElement(false);
        }
    }

    selectEvent(select) {
        for (let i = 0; i < this.userElements.length; i++) {
            let element = $(this.userElements[i]).find('[data-subtype="user-element-checkbox"]')[0];

            if (select && !element.checked) {
                element.checked = true;
                this.checkedCounter++;
            } else if (!select && element.checked) {
                element.checked = false;
                this.checkedCounter--;
            }
        }

        this.updateFansButton();
    }

    fansButtonEvent() {
        let mySelf = this;
        let userIds = [];

        for (let i = 0; i < this.userElements.length; i++) {
            let element = $(this.userElements[i]).find('[data-subtype="user-element-checkbox"]')[0];

            if (element.checked) {
                userIds.push(element.value);
            }
        }

        $.post(
            this.fansUrl,
            {
                'user_ids': userIds
            },
            function () {
                mySelf.reloadUserListContent(false, mySelf.getUserListHashId());
                mySelf.reloadLists();
            },
            'json'
        );
    }

    showLists(show) {
        let lists = this.$element.find('[data-type="lists"]');

        if (show) {
            lists.removeClass('hidden');
        } else {
            lists.addClass('hidden');
        }
    }

    showUsers(show) {
        let users = this.$element.find('[data-subtype="users"]');

        if (show) {
            users.removeClass('hidden');
        } else {
            users.addClass('hidden');
        }
    }

    highlightCurrentListElement(highlight) {
        if (this.listElements.length > 0) {
            this.listElements.removeClass('active');
        }

        if (highlight) {
            let userListHashId = this.getUserListHashId();
            let listElement;

            if (userListHashId) {
                listElement = this.$element.find('[data-list-element-id="' + userListHashId + '"]');
            } else {
                listElement = this.$element.find('[data-subtype="default-list-element"]');
            }

            listElement.addClass('active');
        }
    }

    reloadLists() {
        this.$element.find('[data-type="list-name-search"]').trigger('change');
    }

    updateListName(listName) {
        this.$element.find('[data-type="user-list-name"]').text(listName);
    }

    getUserListHashId() {
        return this.$element.find('[data-type="user-list-id"]').val();
    }

    updateUserListHashId(hashId) {
        this.$element.find('[data-type="user-list-id"]').val(hashId);
    }

    updateWindowUrl(url) {
        window.history.pushState({}, '', url);
    }

    reloadUserListContent(updateWindowUrl, userListHashId = null) {
        let defaultUserListElement = this.$element.find('[data-subtype="default-list-element"]');
        let reloadElementId = defaultUserListElement.data('reload-element-id');
        let userListContentUrl = defaultUserListElement.data('action-url');
        let userListsViewUrl = defaultUserListElement.data('user-lists-view-url');

        if (userListHashId) {
            userListContentUrl += '/' + userListHashId;
            userListsViewUrl += '/' + userListHashId;
        }

        $(document).trigger(
            'content:reload',
            {
                id: reloadElementId,
                url: userListContentUrl,
                postData: 'add_fans_mode=false&remove_fans_mode=false'
            }
        );

        if (updateWindowUrl) {
            this.updateWindowUrl(userListsViewUrl);
        }
    }

    updateFansButton() {
        if (this.checkedCounter > 0) {
            this.fansButton.removeAttr('disabled', 'disabled');
        } else {
            this.fansButton.attr('disabled', 'disabled');
        }
    }

    destroyListener() {
        $(document).off('user-lists:loaded', this.listsLoadedListener);
        $(document).off('user-list-content:loaded', this.contentLoadedListener);
        $(document).off('user-list-users:loaded', this.usersLoadedListener);
        $(document).off('user-list:reload', this.reloadListener);
        $(document).off('user-list:created', this.createListener);
        $(document).off('user-list:renamed', this.renameListener);
        $(document).off('user-list:deleted', this.deleteListener);
        $(document).off('content:resized', this.resizeListener);

        if (this.listElements.length > 0) {
            this.listElements.off('click', this.listElementsListener);
        }

        if (this.userElements.length > 0) {
            this.userElements.off('click', this.userElementsListener);
        }

        if (this.backButton != null) {
            this.backButton.off('click', this.backButtonListener);
        }

        if (this.fansButton != null) {
            this.fansButton.off('click', this.fansButtonListener);
        }

        if (this.selectAllButton != null && this.deselectAllButton != null) {
            this.selectAllButton.off('click', this.selectAllButtonListener);
            this.deselectAllButton.off('click', this.deselectAllButtonListener);
        }
    }
}